var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.updateCardKey, staticClass: "object" },
    [
      !_vm.selectedObject
        ? _c("div", { staticClass: "no object-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SelectObjectMessage")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedObject
        ? _c(
            "div",
            { staticClass: "object-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.cardObjectIdentifier,
                  "identifier-label": _vm.cardObjectIdentifierLabel,
                  "editing-data": false,
                  "show-edit-button": false,
                  "card-label": null,
                  height: _vm.cardHeight
                }
              }),
              _vm._v(" "),
              _vm.selectedObjectIsWorkOrder
                ? _c("workorder-specific-info", {
                    attrs: {
                      "workorder-geom": _vm.object ? _vm.object.geo_json : null,
                      "workorder-objects": _vm.object ? _vm.object.objects : []
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedObjectIsActivity
                ? _c("activity-specific-info", {
                    attrs: { activity: _vm.object ? _vm.object : null }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedObjectIsTask
                ? _c("task-step-specific-info")
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "fixed" },
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d386ecec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d386ecec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/TasksManagement/SelectedObject.vue
// module id = null
// module chunks = 